"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";

// components
import BaseHeader from "@/components/Header/BaseHeader";
import AsideNavigation from "@/components/AsideNavigation";
import AuthHeaderLogo from "@/components/Header/AuthHeader/components/AuthHeaderLogo";

// helpers
import wording from "@/globals/wording.constants";

// assets
import styles from "@/assets/styles/layouts/legal-page-layout.module.scss";


const LEGAL_PAGE_NAVIGATION_LINKS = [
  { label: wording.legal.aside.termsOfUse, value: "/terms-of-use" },
  { label: wording.legal.aside.bookingTerms, value: "/bookingterms" },
  { label: wording.legal.aside.privacyPolicy, value: "/privacy" },
  { label: wording.legal.aside.cookieNotice, value: "/cookies" },
];

export interface LegalPageLayoutProps {
  children: ReactNode;
}

function LegalPageLayout({ children }: LegalPageLayoutProps) {
  const pathname = usePathname();

  return (
    <div className={styles["locl-legal-page-layout"]}>
      <BaseHeader className={styles["locl-legal-page-layout__header"]}>
        <BaseHeader.Logo>
          <AuthHeaderLogo pathname={pathname} />
        </BaseHeader.Logo>
      </BaseHeader>
      <div className={styles["locl-legal-page-layout__body"]}>
        <AsideNavigation navigationLinks={LEGAL_PAGE_NAVIGATION_LINKS} />
        <div className={styles["locl-legal-page-layout__content"]}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default LegalPageLayout;
